export default __webpack_public_path__ + "static/media/Zlata.fe430a6b.png";